import React from 'react';
import { Section, FadeIn, StaggerContainer, StaggerItem } from './ui';
import { Coffee, Activity, Flame, Pill, Moon } from 'lucide-react';
export const ProblemSection = () => {
  const failedAttempts = [{
    icon: <Coffee className="w-6 h-6 text-coral" data-id="element-115" />,
    text: 'El café en ayunas dispara tu cortisol y te deja sin energía a media mañana.'
  }, {
    icon: <Flame className="w-6 h-6 text-coral" data-id="element-116" />,
    text: 'Las dietas restrictivas estresan tu metabolismo y bloquean la quema de grasa.'
  }, {
    icon: <Activity className="w-6 h-6 text-coral" data-id="element-117" />,
    text: 'El ejercicio cardiovascular intenso inflama tus articulaciones y drena tus minerales.'
  }, {
    icon: <Pill className="w-6 h-6 text-coral" data-id="element-118" />,
    text: 'Los suplementos genéricos no consideran el orden biológico que tu cuerpo necesita hoy.'
  }, {
    icon: <Moon className="w-6 h-6 text-coral" data-id="element-119" />,
    text: "Intentar 'dormir más' no soluciona un problema que es de ritmo, no de horas."
  }];
  return <>
      <Section bg="bg-cream" data-id="element-120">
        <FadeIn data-id="element-121">
          <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-122">
            <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-123">
              Te despiertas después de 8 horas de sueño, pero sientes que no has
              dormido nada.
            </h2>
            <p className="text-lg text-brown-light mb-6" data-id="element-124">
              El peso de las sábanas parece excesivo y tu primer pensamiento no
              es "buenos días", es "¿cuánto falta para volver a la cama?".
            </p>
            <p className="text-lg text-brown-light font-medium" data-id="element-125">
              No es falta de voluntad y no es algo con lo que "tengas que vivir"
              solo por tener más de 50 años. Lo que sientes es un divorcio
              biológico entre tus hábitos y tu nueva realidad hormonal.
            </p>
          </div>
        </FadeIn>

        <div className="grid md:grid-cols-2 gap-12 items-center mt-20" data-id="element-126">
          <FadeIn delay={0.2} data-id="element-127">
            <div className="bg-white p-8 md:p-10 rounded-2xl shadow-sm border border-cream-dark" data-id="element-128">
              <h3 className="text-2xl font-bold mb-6 text-brown" data-id="element-129">
                A los 50+, tu cuerpo ha cambiado las reglas del juego.
              </h3>
              <div className="space-y-4 text-brown-light" data-id="element-130">
                <p data-id="element-131">
                  El estrógeno ha bajado, tu sensibilidad a la insulina es
                  distinta y tu gestión del cortisol (la hormona del estrés) es
                  mucho más delicada.
                </p>
                <p data-id="element-132">
                  Seguir los consejos de nutrición de una revista genérica o
                  tomar café en exceso solo empeora el problema.
                </p>
                <p className="font-medium text-brown bg-cream-light p-4 rounded-lg mt-6" data-id="element-133">
                  Estás forzando a un motor cansado a ir a máxima velocidad sin
                  darle el combustible correcto, lo que genera ese círculo
                  vicioso de cansancio por la mañana y alerta ansiosa por la
                  noche.
                </p>
              </div>
            </div>
          </FadeIn>

          <div className="space-y-8" data-id="element-134">
            <FadeIn delay={0.3} data-id="element-135">
              <h3 className="text-2xl font-bold mb-2" data-id="element-136">
                Por qué lo que has intentado no funciona
              </h3>
              <p className="text-brown-light mb-8" data-id="element-137">
                Tu cuerpo no necesita más esfuerzo, necesita alineación.
              </p>
            </FadeIn>

            <StaggerContainer className="space-y-4" data-id="element-138">
              {failedAttempts.map((item, index) => <StaggerItem key={index} data-id="element-139">
                  <div className="flex gap-4 items-start" data-id="element-140">
                    <div className="mt-1 bg-cream-dark/30 p-2 rounded-full" data-id="element-141">
                      {item.icon}
                    </div>
                    <p className="text-brown-light leading-relaxed" data-id="element-142">
                      {item.text}
                    </p>
                  </div>
                </StaggerItem>)}
            </StaggerContainer>
          </div>
        </div>
      </Section>
    </>;
};